import { Box, SxProps, Typography } from '@mui/material';
import React from 'react';

const container: SxProps = {
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: 'customGrey.medium',
  width: '100%',
  p: 4
};

const innerContainer: SxProps = {
  mt: 1
};

type Props = {
  title: string | React.ReactNode;
  children: React.ReactNode;
};

export const Card: React.FC<Props> = ({ title, children }) => {
  return (
    <Box sx={container}>
      <Typography variant="h5" color="primary">
        {title}
      </Typography>
      <Box sx={innerContainer}>{children}</Box>
    </Box>
  );
};
